import { validateLoanStartDate } from '../../lib/validation';

/**
 * Loan Start Date Input
 */
export const loanStartDate = {
  name: 'loanStartDate',
  type: 'string',
  validators: [validateLoanStartDate],
};
